import { useEffect, useState } from "react";
import Sidebar from "../Components/Sidebar";
import Topbar from "../Components/Topbar";
import DashboardShell from "../../components/ui/DashboardShell";
import {useAuth} from '../Context/AuthContext';

export default function DashboardLayout({ children }) {
  const auth=useAuth();
  const [collapsed, setCollapsed] = useState(() => {
    const saved = localStorage.getItem("sidebarCollapsed");
    return saved === "true";
  });
  const [permissions, setPermissions] = useState([]);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/admin/me", {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setPermissions(data.permissions || []);
          setRole(data.admin.role);
        } else {
          window.location.href = "/adminlogin";
        }
      })
      .catch(() => {
        window.location.href = "/adminlogin";
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="min-h-screen bg-[#07070b]" />;
  }

  const toggleCollapsed = (value) => {
    setCollapsed(value);
    localStorage.setItem("sidebarCollapsed", value);
  };

  return <DashboardShell Sidebar={Sidebar} Topbar={Topbar} sidebarProps={{ permissions:auth?auth.permissions:permissions, role:auth?auth.user?.role:role }} collapsed={collapsed} setCollapsed={toggleCollapsed}>
    {children}
  </DashboardShell>;
}
